<template>
    <div>
        <modal
            :title="translations?.requestPayout || 'Request a payout'"
            size="small"
            @modalClose="() => this.requestErrors = null"
            :loading="loading.requestPayout || loading.refreshBankRequirements"
        >
            <template #toggle>
                <btn :type="styles.button_color ?? custom">{{ translations?.requestPayout || 'Request a payout' }}</btn>
            </template>
            <template #body>
                <partner-payout-request-fields
                    ref="payoutFields"
                    :countries="countries"
                    :placeholders="placeholders"
                    :amount_unit="amount_unit"
                    :amount_with_units_formatted="amount_with_units_formatted"
                    :preferred_settings="preferred_settings"
                    :available_methods="available_methods"
                    :translations="translations"
                    :request-errors="requestErrors"
                    :refresh_bank_requirements_url="refresh_bank_requirements_url"
                    :payout_invoice_requirements="payout_invoice_requirements"
                    :bill_to_details="bill_to_details"
                    @loading-refresh-bank-requirements="handleRefreshBankRequirementsLoading"
                    @request-errors="requestErrors = $event"
                />
            </template>
            <template #footer>
                <btn :loading="loading.requestPayout"
                     :type="styles.button_color ?? custom"
                     @click="requestPayout"
                >
                    {{ translations?.request || 'Request' }}
                </btn>
            </template>
        </modal>
    </div>
</template>
<script>
export default {
    props: [
        'countries',
        'placeholders',
        'request_url',
        'amount_unit',
        'amount_with_units_formatted',
        'preferred_settings',
        'styles',
        'available_methods',
        'translations',
        'refresh_bank_requirements_url',
        'payout_invoice_requirements',
        'bill_to_details'
    ],
    data() {
        return {
            loading: {
                requestPayout: false,
                refreshBankRequirements: false
            },
            requestErrors: null,
        }
    },
    methods: {
        requestPayout() {

            if (this.loading.requestPayout || this.loading.refreshBankRequirements || !this.$refs.payoutFields.validatePaymentInfo()) {
                return;
            }

            this.requestErrors = null;
            this.loading.requestPayout = true;

            axios.post(this.request_url, {
                amount_unit: this.$refs.payoutFields.getAmountUnit(),
                settings: {
                    requested_payment_settings: this.$refs.payoutFields.getPaymentSettings()
                },
                invoice_path: this.$refs.payoutFields.getInvoicePath()
            })
                .then(response => {
                    const status = parseInt(response.data.status ?? -1);
                    if (status === 1) {
                        window.location.reload();
                    } else if (status === 0 && response.data.bank_transfer_fields) {
                        this.$refs.payoutFields.setBankTransferFields(response.data.bank_transfer_fields)
                        this.requestErrors = {additional_fields: response.data.errors}
                    }
                })
                .catch(error => {
                    if (error.response && error.response.data && error.response?.data?.errors) {
                        this.requestErrors = Array.isArray(error.response.data.errors)
                            ? {additional_error: error.response.data.errors}
                            : error.response.data.errors;
                    }
                })
                .finally(() => this.loading.requestPayout = false);
        },
        handleRefreshBankRequirementsLoading(loading) {
            if (loading) {
                this.requestErrors = null;
            }
            this.loading.refreshBankRequirements = loading
        }
    }
}
</script>
